/* ---- Nav scroll state + sticky CTA reveal ---- */
const nav=document.getElementById('nav'), sticky=document.getElementById('stickyCta');
window.addEventListener('scroll',()=>{
  const y=window.scrollY;
  nav.classList.toggle('scrolled', y>10);
  sticky.classList.toggle('show', y>700);
},{passive:true});

/* ---- Mobile menu toggle ---- */
const navToggle=document.getElementById('navToggle'), mobileMenu=document.getElementById('mobileMenu');
function closeMenu(){ navToggle.classList.remove('active'); mobileMenu.classList.remove('open'); }
navToggle.addEventListener('click',()=>{
  const open=mobileMenu.classList.toggle('open');
  navToggle.classList.toggle('active', open);
});
mobileMenu.querySelectorAll('a').forEach(a=>a.addEventListener('click',closeMenu));
window.addEventListener('resize',()=>{ if(window.innerWidth>720) closeMenu(); });

/* ---- Reveal on scroll ---- */
const io=new IntersectionObserver((entries)=>{
  entries.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
},{threshold:.12});
document.querySelectorAll('.reveal').forEach(el=>io.observe(el));

/* ---- Pricing billing toggle ---- */
const toggle=document.getElementById('billingToggle');
toggle.addEventListener('click',e=>{
  const btn=e.target.closest('button'); if(!btn)return;
  toggle.querySelectorAll('button').forEach(b=>b.classList.remove('active'));
  btn.classList.add('active');
  const f=+btn.dataset.freq;
  document.querySelectorAll('.plan .amt').forEach(a=>{ a.textContent=a.dataset.prices.split('|')[f]; });
  document.querySelectorAll('.plan .freq-note').forEach(n=>{ n.textContent=n.dataset.notes.split('|')[f]; });
});

/* ================= QUIZ ================= */
const answers={};
const steps=document.querySelectorAll('.q-step');
const bar=document.getElementById('qBar');
const backBtn=document.getElementById('qBack');
const result=document.getElementById('qResult');
const qNav=document.getElementById('qNav');
let cur=0;
const TOTAL=steps.length;

function show(i){
  steps.forEach((s,idx)=>s.classList.toggle('active',idx===i));
  bar.style.width=(((i+0.5)/TOTAL)*100)+'%';
  backBtn.disabled = i===0;
}
function selectOpt(stepEl,btn){
  const key=stepEl.querySelector('.q-options').dataset.key;
  stepEl.querySelectorAll('.q-opt').forEach(o=>o.classList.remove('sel'));
  btn.classList.add('sel');
  answers[key]=btn.dataset.val;
  setTimeout(()=>{
    if(cur<TOTAL-1){ cur++; show(cur); }
    else { computeResult(); }
  },230);
}
steps.forEach(stepEl=>{
  stepEl.querySelectorAll('.q-opt').forEach(btn=>{
    btn.addEventListener('click',()=>selectOpt(stepEl,btn));
  });
});
backBtn.addEventListener('click',()=>{ if(cur>0){cur--;show(cur);} });

/* ---- Recommendation logic ---- */
function computeResult(){
  const pets=answers.pets==='yes';
  const allergies=answers.allergies==='yes';
  const people=answers.people; // '1-2','3-4','5+'
  const count=parseInt(answers.count)||1;

  let plan, merv, monthly, two, three, why;

  /* Evidence-based MERV selection (ASHRAE 52.2 particle-size capability):
     • MERV 8  — captures larger common particles: dust, lint, pollen, mold spores (~3–10 microns).
     • MERV 11 — adds finer dust and pet dander (~1–3 microns) while keeping airflow healthy.
     • MERV 13 — captures fine particles toward 0.3–1 micron (fine allergens, smoke-sized particulate);
                 the level most often recommended specifically for allergy / asthma households.
     Higher MERV also restricts airflow more, so we only step up when there's a reason to —
     allergies/asthma drive MERV 13; pets are well handled at MERV 11; otherwise MERV 8 is plenty. */
  if(allergies){
    plan='Pets & Allergies'; merv='MERV 13';
    why = pets
      ? 'Because someone in the home has allergies or asthma — and you have pets — MERV 13 is the level most often recommended. It captures the finest everyday particles, down toward the 0.3–1 micron range (fine pet dander, pollen fragments, and smoke-sized particulate) that lower-rated filters let pass.'
      : 'For allergy or asthma-sensitive homes, MERV 13 captures the finest everyday particles — toward the 0.3–1 micron range, including fine pollen, mold fragments, and smoke-sized particulate. That fine-particle capture is why it\u2019s the level most often recommended for sensitive households.';
  } else if(pets){
    plan='Family Home'; merv='MERV 11';
    why='Pet dander sits in a particle range that MERV 11 captures well, along with finer dust — without over-restricting your system\u2019s airflow. Stepping all the way to MERV 13 generally isn\u2019t needed unless someone in the home is allergy or asthma-sensitive, so MERV 11 is the right balance for a pet household.';
  } else if(people==='5+'){
    plan='Family Home'; merv='MERV 11';
    why='A larger, higher-traffic household puts more dust and airborne particles into circulation, so MERV 11 steps up capture of finer dust and particulate while keeping airflow healthy.';
  } else {
    plan='Basic Home'; merv='MERV 8';
    why='Without pets or allergy sensitivities, MERV 8 captures the everyday particles most homes deal with — dust, lint, pollen, and mold spores — while keeping airflow open and your system efficient. A higher rating would restrict airflow more without a clear benefit for your situation.';
  }
  const P={'Basic Home':[19.99,18.99,17.99],'Family Home':[24.99,23.99,22.99],'Pets & Allergies':[29.99,28.99,27.99]}[plan];
  monthly=P[0]; two=P[1]; three=P[2];

  // Delivery schedule + per-filter price come from the customer's chosen frequency
  const schedule = answers.freq || 'Every 2 months';
  const freqIdx = ['Monthly','Every 2 months','Every 3 months'].indexOf(schedule);
  const unit = [monthly, two, three][freqIdx < 0 ? 1 : freqIdx];

  const total=(unit*count).toFixed(2);
  lastRec={plan:plan, merv:merv, schedule:schedule, qty:count, unit:unit};

  document.getElementById('rMerv').textContent=merv;
  document.getElementById('rPlan').textContent=plan;
  document.getElementById('rPlanName').textContent=plan+' ('+merv+')';
  document.getElementById('rWhy').textContent=why;
  document.getElementById('rCount').textContent=count + (count>1?' filters':' filter');
  document.getElementById('rSchedule').textContent=schedule;
  document.getElementById('rTotal').textContent='$'+total;

  steps.forEach(s=>s.classList.remove('active'));
  qNav.style.display='none';
  result.classList.add('show');
  bar.style.width='100%';
}
document.getElementById('qRestart').addEventListener('click',()=>{
  Object.keys(answers).forEach(k=>delete answers[k]);
  document.querySelectorAll('.q-opt').forEach(o=>o.classList.remove('sel'));
  document.querySelectorAll('.r-size-chip').forEach(c=>c.classList.remove('sel'));
  document.getElementById('rSizeInput').value='';
  document.getElementById('rSizeLine').style.display='none';
  result.classList.remove('show');
  qNav.style.display='flex';
  cur=0; show(0);
});

/* ---- Size entry on the result screen ---- */
const sizeInput=document.getElementById('rSizeInput');
const sizeLine=document.getElementById('rSizeLine');
const sizeVal=document.getElementById('rSizeVal');
function setSize(val){
  const v=(val||'').trim();
  if(v){ sizeVal.textContent=v; sizeLine.style.display='flex'; }
  else { sizeLine.style.display='none'; }
}
document.querySelectorAll('.r-size-chip').forEach(chip=>{
  chip.addEventListener('click',()=>{
    document.querySelectorAll('.r-size-chip').forEach(c=>c.classList.remove('sel'));
    chip.classList.add('sel');
    sizeInput.value=chip.dataset.size;
    setSize(chip.dataset.size);
  });
});
sizeInput.addEventListener('input',()=>{
  document.querySelectorAll('.r-size-chip').forEach(c=>{
    c.classList.toggle('sel', c.dataset.size.toLowerCase()===sizeInput.value.trim().toLowerCase());
  });
  setSize(sizeInput.value);
});

/* ================= CHECKOUT ================= */
let lastRec=null;
const IS_SHOPIFY = typeof window.Shopify !== 'undefined';

/* ── CONNECT YOUR PRODUCTS ───────────────────────────────────────────────────
   Create 3 subscription products in Shopify with these exact handles (or change
   the handles below to match yours). Add your filter sizes as variants and your
   delivery frequencies as subscription/selling plans.

   That's it — the button automatically looks up the product, matches the size to
   a variant, picks the right delivery plan, adds it to the cart, and sends the
   customer STRAIGHT TO CHECKOUT. No variant IDs to copy by hand.

   (Optional) If your selling-plan names don't contain "month", paste the exact
   selling-plan IDs into sellingPlans below to force the right match. */
const AIRVO = {
  plans: {
    'Basic Home':       { handle:'basic-home',     sellingPlans:{ 'Monthly':'', 'Every 2 months':'', 'Every 3 months':'' } },
    'Family Home':      { handle:'family-home',     sellingPlans:{ 'Monthly':'', 'Every 2 months':'', 'Every 3 months':'' } },
    'Pets & Allergies': { handle:'pets-allergies',  sellingPlans:{ 'Monthly':'', 'Every 2 months':'', 'Every 3 months':'' } }
  }
};

function freqFromToggle(){
  const f=+(toggle.querySelector('button.active')||{}).dataset?.freq||0;
  return ['Monthly','Every 2 months','Every 3 months'][f]||'Monthly';
}
function norm(s){return (s||'').toString().toLowerCase().replace(/[^a-z0-9]/g,'');}

/* Find the variant that matches the customer's size, handling single-variant products too */
function pickVariant(product, size){
  if(!product || !product.variants || !product.variants.length) return null;
  if(product.variants.length===1) return product.variants[0]; // size tracked as a property
  const want=norm(size);
  if(want){
    const m=product.variants.find(v=>norm(v.title).includes(want) || (v.options||[]).some(o=>norm(o)===want));
    if(m) return m;
  }
  return null; // no size match → let the customer choose on the product page
}

/* Resolve the subscription selling plan for the chosen frequency */
function pickSellingPlan(cfg, product, schedule){
  if(cfg.sellingPlans[schedule]) return cfg.sellingPlans[schedule];        // 1) configured ID wins
  const groups=(product&&product.selling_plan_groups)||[];
  const plans=groups.flatMap(g=>g.selling_plans||[]);
  if(!plans.length) return '';
  const kw={'Monthly':/month/i,'Every 2 months':/(2|two)\s*month/i,'Every 3 months':/(3|three)\s*month/i}[schedule];
  if(schedule==='Monthly'){ const p=plans.find(p=>/month/i.test(p.name)&&!/[23]|two|three/i.test(p.name)); if(p) return p.id; }
  else if(kw){ const p=plans.find(p=>kw.test(p.name)); if(p) return p.id; }
  const idx=['Monthly','Every 2 months','Every 3 months'].indexOf(schedule);   // 3) fall back to order created
  return (plans[idx]||plans[0]).id;
}

async function getProduct(handle){
  try{
    const r=await fetch('/products/'+handle+'.js',{headers:{'Accept':'application/json'}});
    if(r.ok) return await r.json();
  }catch(e){}
  return null; // product doesn't exist yet
}

async function startCheckout(plan, schedule, qty, size, btn){
  const cfg=AIRVO.plans[plan]; if(!cfg) return;

  // Outside a live Shopify store → show the preview of what checkout will receive
  if(!IS_SHOPIFY){ showCheckoutPreview(plan, schedule, qty, size); return; }

  const setLoading=on=>{ if(!btn)return; if(on){btn.dataset.label=btn.dataset.label||btn.textContent;btn.textContent='Setting up your order…';btn.style.pointerEvents='none';btn.style.opacity='.7';} else {btn.textContent=btn.dataset.label||btn.textContent;btn.style.pointerEvents='';btn.style.opacity='';} };
  setLoading(true);

  // Look up the real product BEFORE navigating anywhere (prevents 404s)
  const product=await getProduct(cfg.handle);
  if(!product){ setLoading(false); showSetupNeeded(plan); return; }

  const variant=pickVariant(product, size);
  const sellingPlan=pickSellingPlan(cfg, product, schedule);

  // Matched a specific variant (or single-variant product) → add to cart + go straight to checkout
  if(variant){
    const item={ id:variant.id, quantity:qty,
      properties:{ 'Recommended plan':plan, 'Filter size':(size&&size.trim())?size.trim():'To confirm', 'Delivery':schedule } };
    if(sellingPlan) item.selling_plan=sellingPlan;
    try{
      const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[item]})});
      if(r.ok){ window.location.href='/checkout'; return; }
    }catch(e){}
  }

  // Product exists but we couldn't lock the exact size → send to the real product page to confirm size
  const u=new URL('/products/'+cfg.handle, window.location.origin);
  if(sellingPlan) u.searchParams.set('selling_plan',sellingPlan);
  if(size&&size.trim()) u.searchParams.set('size',size.trim());
  window.location.href=u.toString();
}

/* pick the first available variant as a fallback when the size isn't a stocked variant */
function firstAvailable(product){
  if(!product||!product.variants||!product.variants.length) return null;
  return product.variants.find(v=>v.available) || product.variants[0];
}

/* QUIZ path → always add to cart and go STRAIGHT to checkout.
   The customer's size is written to the order note (and a line-item property)
   so it shows on the order/invoice — even when it isn't a stocked size. */
async function quizCheckout(rec, size, btn){
  const cfg=AIRVO.plans[rec.plan]; if(!cfg) return;
  if(!IS_SHOPIFY){ showCheckoutPreview(rec.plan, rec.schedule, rec.qty, size); return; }
  const setLoading=on=>{ if(!btn)return; if(on){btn.dataset.label=btn.dataset.label||btn.textContent;btn.textContent='Setting up your order…';btn.style.pointerEvents='none';btn.style.opacity='.7';} else {btn.textContent=btn.dataset.label||btn.textContent;btn.style.pointerEvents='';btn.style.opacity='';} };
  setLoading(true);

  const product=await getProduct(cfg.handle);
  if(!product){ setLoading(false); showSetupNeeded(rec.plan); return; }

  const matched=pickVariant(product, size);
  const variant=matched || firstAvailable(product);
  if(!variant){ setLoading(false); showSetupNeeded(rec.plan); return; }
  const sellingPlan=pickSellingPlan(cfg, product, rec.schedule);

  const cleanSize=(size&&size.trim())?size.trim():'';
  const nonStandard = cleanSize && !matched && product.variants.length>1;

  const props={ 'Plan':rec.plan+' ('+rec.merv+')', 'Delivery':rec.schedule,
                'Filter size': cleanSize || 'To be confirmed' };
  const item={ id:variant.id, quantity:rec.qty, properties:props };
  if(sellingPlan) item.selling_plan=sellingPlan;

  try{
    const add=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[item]})});
    if(!add.ok) throw 0;
    // Order note — visible on the order/invoice in Shopify admin. Always records the size.
    let note='AIRVO order — '+rec.plan+' ('+rec.merv+'), '+rec.schedule+', qty '+rec.qty+'. ';
    note += cleanSize ? ('Requested filter size: '+cleanSize+'.') : 'Filter size to be confirmed with customer.';
    if(nonStandard) note += ' ** NON-STANDARD SIZE — please fulfill at the requested size above. **';
    await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({note:note})});
    window.location.href='/checkout';
  }catch(e){ setLoading(false); alert('Sorry, something went wrong starting your subscription. Please try again.'); }
}

/* friendly message when the matching product hasn't been created in Shopify yet */
function showSetupNeeded(plan){
  document.getElementById('cpPlan').textContent=plan;
  document.getElementById('cpFreq').textContent='—';
  document.getElementById('cpQty').textContent='—';
  document.getElementById('cpSize').textContent='—';
  document.getElementById('cpTotal').textContent='—';
  document.querySelector('#checkoutModal h3').textContent='Almost ready';
  document.querySelector('#checkoutModal .sub').textContent='This plan is matched and ready to sell.';
  document.querySelector('#checkoutModal .airvo-modal-sum').style.display='none';
  document.querySelector('#checkoutModal .airvo-modal-note').textContent='To take live orders, create a product in Shopify with the handle "'+(AIRVO.plans[plan].handle)+'" and its delivery options. Once it exists, this button adds it to the cart and goes straight to checkout automatically.';
  document.getElementById('checkoutModal').classList.add('show');
}

/* preview modal — only appears outside a live Shopify store */
function showCheckoutPreview(plan, schedule, qty, size){
  const cfg=AIRVO.plans[plan];
  const unit=lastRec&&lastRec.plan===plan?lastRec.unit:({'Basic Home':[19.99,18.99,17.99],'Family Home':[24.99,23.99,22.99],'Pets & Allergies':[29.99,28.99,27.99]}[plan][['Monthly','Every 2 months','Every 3 months'].indexOf(schedule)]);
  const total=(unit*qty).toFixed(2);
  document.getElementById('cpPlan').textContent=plan;
  document.getElementById('cpFreq').textContent=schedule;
  document.getElementById('cpQty').textContent=qty+(qty>1?' filters':' filter');
  document.getElementById('cpSize').textContent=(size&&size.trim())?size.trim():'To confirm';
  document.getElementById('cpTotal').textContent='$'+total;
  document.getElementById('checkoutModal').classList.add('show');
}

/* result CTA → straight to checkout with the recommended plan + size in order notes */
document.getElementById('rCheckout').addEventListener('click',function(e){
  e.preventDefault();
  if(!lastRec) return;
  quizCheckout(lastRec, sizeInput.value, this);
});

/* plan-grid CTAs → checkout for the chosen plan at the selected frequency */
document.querySelectorAll('.plan-cta').forEach(b=>{
  b.addEventListener('click',function(e){
    e.preventDefault();
    const plan=this.dataset.plan.replace('&amp;','&');
    startCheckout(plan, freqFromToggle(), 1, '', this);
  });
});

/* modal close (checkout preview) */
document.addEventListener('click',e=>{
  if(e.target.id==='checkoutModal'||e.target.id==='cpClose'){
    document.getElementById('checkoutModal').classList.remove('show');
  }
});

/* generic modal open/close (contact, manage subscription) */
function syncModalLock(){ document.body.classList.toggle('modal-open', !!document.querySelector('.airvo-modal.show')); }
document.querySelectorAll('[data-open]').forEach(function(el){
  el.addEventListener('click',function(e){ e.preventDefault(); var m=document.getElementById(this.getAttribute('data-open')); if(m){ m.classList.add('show'); syncModalLock(); } });
});
document.addEventListener('click',function(e){
  var c=e.target.closest('[data-close]');
  if(c){ var m=document.getElementById(c.getAttribute('data-close')); if(m) m.classList.remove('show'); }
  if(e.target.classList && e.target.classList.contains('airvo-modal')){ e.target.classList.remove('show'); }
  syncModalLock();
});

/* after a contact/manage form sends, Shopify reloads with ?contact_posted=true → confirm */
(function(){
  try{
    var p=new URLSearchParams(window.location.search);
    if(p.get('contact_posted')==='true'){
      var m=document.getElementById('sentModal'); if(m){ m.classList.add('show'); syncModalLock(); }
      history.replaceState(null,'',window.location.pathname);
    }
  }catch(e){}
})();

show(0);